import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const useTrackRouteChangeHook = (hash?: string) => {
  const prevHashRef = useRef<string | undefined>(hash);
  const location = useLocation();

  useEffect(() => {
    // Only trigger if hash changed and is not the initial render
    if (hash !== prevHashRef.current) {
      const event = new CustomEvent('internalRouteChanged', { detail: { location: location } });
      window.dispatchEvent(event);
    }
    
    // Update the previous hash value
    prevHashRef.current = hash;
  }, [hash]);
};

export default useTrackRouteChangeHook;